import { useState } from 'react';

import { ListItem, Collapse, ListItemIcon, ListItemText } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useSideMenuItemStyles } from './SideMenuItem.styles';
import { Menu } from '../Menu';
import { MenuItem } from '../Menu.types';

export type SideMenuItemProps = {
  item: MenuItem;
};

export const SideMenuItem = ({ item }: SideMenuItemProps) => {
  const { callback, icon, subItems, text, tab = 0, selected, route } = item;
  const [open, setOpen] = useState(false);
  const classes = useSideMenuItemStyles({ tab });

  const toggleOpen = () => {
    setOpen(!open);
  };

  const handleClick = event => {
    if (subItems && subItems.length) {
      toggleOpen();
      return;
    }

    if (event.ctrlKey || event.metaKey) {
      if (route) {
        window.open(`/${route || ''}`, '_blank');
      }
      return;
    }

    typeof callback === 'function' && callback(item);
  };

  const LinkBehavior = props => {
    const { children, ...other } = props;

    const handleAuxClick = event => {
      if (event.button === 1 && route) {
        window.open(`/${route || ''}`, '_blank');
        event.preventDefault();
      }
    };

    return (
      <ListItem
        {...other}
        onAuxClick={handleAuxClick}
        component={route ? 'div' : 'li'}
        role={route ? 'link' : undefined}
      >
        {children}
      </ListItem>
    );
  };

  return (
    <>
      <LinkBehavior
        className={classes.item}
        button
        onClick={handleClick}
        selected={selected}
        data-testid={`side-menu-item-${text}`}
      >
        {icon && <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>}
        <ListItemText classes={{ primary: classes.text }} primary={text} />
        {subItems && (open ? <ArrowDropDownIcon /> : <ArrowRightIcon />)}
      </LinkBehavior>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {subItems && <Menu items={subItems} />}
      </Collapse>
    </>
  );
};
